import React from "react";
import PhoenixFormPreview from "./PhoenixFormPreview";

interface Props {
  match: { params: { phoenixFormId: string } },
}

const PublicFormPreview = (props: Props) => {
  return <PhoenixFormPreview pnxFormId={props.match.params.phoenixFormId} isAnonymous showFormNameHeader/>
};

export default PublicFormPreview;
